import { useContext } from 'react';
import { UniversalSearchContext } from './UniversalSearchProvider';
export function useUniversalSearch() {
    const context = useContext(UniversalSearchContext);
    if (!context) {
        throw new Error('useSearchPopup must be used within a SearchPopupProvider');
    }
    return context;
}
